import { getURIParam } from '@/common/utils';

/**
 * dw异步模块，支持缓存队列，加载完成后上报
 */
class DwService {
  constructor(AppKey) {
    this.AppKey = AppKey;
    this.version = '0';
    this.accountId = '';
    this.cacheQueue = [];
    this.isReady = false;

    console.log('NODE_ENV', process.env.NODE_ENV);
    this.isDebug = process.env.NODE_ENV == 'production' ? false : true;
  }

  init({ accountId = '', version = '0' }) {
    this.version = version;
    this.loadScript().then(() => {
      if (window._dw) {
        this.setAppKey();
        this.setVersion();
        this.setChannel();
        this.setDebug();
        this.setAccountId(accountId);

        while (this.cacheQueue.length) {
          let evt = this.cacheQueue.shift();
          this.onEvent(evt.event, evt.data);
        }
        this.isReady = true;
      }
    });
  }

  setAppKey() {
    window._dw.setAppKey(this.AppKey);
  }

  setVersion() {
    window._dw.setVersion(this.version);
  }

  setDebug() {
    window._dw.setDebug(this.isDebug);
  }

  setAccountId(accountId) {
    this.accountId = accountId;
    window._dw.setAccountId(accountId);
  }

  setChannel() {
    const chan = getURIParam('chan');
    window._dw.setChannel(chan);
  }

  loadScript() {
    return new Promise((resolve) => {
      let id = 'dw-web-sdk';
      let isExist = document.getElementById(id);

      if (isExist) {
        resolve();
      } else {
        let script = document.createElement('script');
        let head = document.getElementsByTagName('head')[0];
        script.src =
          'https://fe-static.wpscdn.cn/common/js/dw-min-2.6.15.js';
        script.id = id;
        script.onload = () => {
          resolve();
        };
        head.appendChild(script);
      }
    });
  }

  onEvent(event, data) {
    window._dw.onEvent(event, data);
  }

  /**
   * 打点方法
   *  - 未初始化会先将点缓存，初始化后统一执行
   * @param {*} event
   * @param {*} data
   */
  collect(event, data) {
    // 拦截非法数据类型上报，只允许string/number/boolean类型数据上报
    for (let key in data) {
      if (['string', 'number', 'boolean'].indexOf(typeof data[key]) == -1) {
        // 通过warn暴露异常上报信息
        console.warn('【埋点数据异常】',{event, invalidKey: key, invalidType: Object.prototype.toString.call(data[key])});
        delete data[key];
      }
    }
    if (this.isReady) {
      this.onEvent(event, data);
    } else {
      this.cacheQueue.push({
        event,
        data,
      });
    }
  }
}

export default DwService;
